export const matchQuery = (value: string, query: string): boolean => {
    const queryParts = splitByStopwords(sanitize(query));
    const optionNameParts = splitByStopwords(sanitize(value));

    return queryParts.every((queryPart: string) =>
        optionNameParts.some((optionNamePart: string) => optionNamePart.startsWith(queryPart))
    );
};

const sanitize = (value: string): string => removeSpecialSigns(value.trim().toLowerCase());

const stopwords = ["_", "-"];
const splitByStopwords = (value: string) => replaceAll(value, stopwords, " ").split(" ");

const specialSigns = [",", "[", "]", "(", ")"];
const removeSpecialSigns = (value: string) => replaceAll(value, specialSigns, "");

const replaceAll = (value: string, searchValues: string[], replaceValue: string): string =>
    searchValues.reduce(
        (newValue, searchValue) => newValue.replace(new RegExp(escapeRegExp(searchValue), "g"), replaceValue),
        value
    );

const escapeRegExp = (regexString: string) => regexString.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
